var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2501 8.02662C17.5997 8.02662 17.8831 7.74324 17.8831 7.39368C17.8831 7.04412 17.5997 6.76074 17.2501 6.76074C16.9006 6.76074 16.6172 7.04412 16.6172 7.39368C16.6172 7.74324 16.9006 8.02662 17.2501 8.02662Z",
    fill: "#B1BFB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0625 3H8.9375C5.65881 3 3 5.65881 3 8.9375V16.0625C3 19.3412 5.65881 22 8.9375 22H16.0625C19.3412 22 22 19.3412 22 16.0625V8.9375C22 5.65881 19.3412 3 16.0625 3ZM20.2188 16.0625C20.2188 18.3544 18.3544 20.2188 16.0625 20.2188H8.9375C6.64563 20.2188 4.78125 18.3544 4.78125 16.0625V8.9375C4.78125 6.64563 6.64563 4.78125 8.9375 4.78125H16.0625C18.3544 4.78125 20.2188 6.64563 20.2188 8.9375V16.0625Z",
    fill: "#B1BFB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.75C9.87681 7.75 7.75 9.87681 7.75 12.5C7.75 15.1232 9.87681 17.25 12.5 17.25C15.1232 17.25 17.25 15.1232 17.25 12.5C17.25 9.87681 15.1232 7.75 12.5 7.75ZM12.5 15.4688C10.8636 15.4688 9.53125 14.1364 9.53125 12.5C9.53125 10.8624 10.8636 9.53125 12.5 9.53125C14.1364 9.53125 15.4688 10.8624 15.4688 12.5C15.4688 14.1364 14.1364 15.4688 12.5 15.4688Z",
    fill: "#B1BFB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1866f1028b1878a93e342d97ecdd9de9.svg";
export { ForwardRef as ReactComponent };